import ItemMediaPreview from './ItemMediaPreview'

export default {
    name: 'ProductMediaPreview',
    extends: ItemMediaPreview,
    computed: {
        media() {
            let media = _.get(this.item, 'media') || []
            return media.find(el => el.type === 'image' && el.settings.show.list)
                || media.find(el => el.type === 'image' && el.settings.show.detail)
        },
    },
}
